import api from "./api";

// ── Subscription Tiers ──────────────────────────────────────────────────
/** List all active subscription tiers with their feature entitlements. */
export const getSubscriptionTiers = () =>
  api.get("/subscriptions/tiers/");

/** List active trial offerings for signup. Public endpoint; auth token optional. */
export const getActiveTrialSubscriptions = () =>
  api.get("/subscriptions/trials/active/");

// ── My Subscription ─────────────────────────────────────────────────────
/** Get the current user's active subscription. */
export const getMySubscription = () =>
  api.get("/subscriptions/me/subscription");

/** Get the current user's effective access snapshot for frontend gating. */
export const getMyAccess = () =>
  api.get("/subscriptions/me/access");

// ── My Usage ────────────────────────────────────────────────────────────
/** Get quota-metered feature usage for the current user's tier. */
export const getMyUsage = () =>
  api.get("/subscriptions/me/usage");

// ── Change Subscription ─────────────────────────────────────────────────
/**
 * Switch to a free tier (paid tiers go through startSubscriptionCheckout).
 * @param {string} tierCode - The tier code to switch to.
 */
export const changeSubscription = (tierCode) =>
  api.post("/subscriptions/me/change/", { tier_code: tierCode });

// ── Paid plan checkout ──────────────────────────────────────────────────
/**
 * Start a paid-plan checkout; redirect the user to the returned approval_url.
 * @param {{ tier_code: string, interval: "month"|"year", gateway: string, success_url?: string, cancel_url?: string }} data
 */
export const startSubscriptionCheckout = (data) =>
  api.post("/subscriptions/me/checkout/", data);

/**
 * Re-check a checkout after returning from the gateway (activates the plan once approved).
 * @param {string} subscriptionId - The `subscription` id from the checkout response / return URL.
 */
export const confirmSubscriptionCheckout = (subscriptionId) =>
  api.post("/subscriptions/me/checkout/confirm/", { subscription_id: subscriptionId });

// ── Cancel Subscription ─────────────────────────────────────────────────
/**
 * Cancel the current user's subscription.
 * @param {string} reason - Optional cancellation reason.
 */
export const cancelSubscription = (reason = "") =>
  api.post("/subscriptions/me/cancel/", { reason });
